import {
  Box,
  Button,
  ButtonGroup,
  Grid2,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const NoInfoContainerStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 24,
  '& svg': {
    color: theme.palette.global.lightgray,
  },
  '& h2': {
    color: theme.palette.global.lightgray,
  },
}));

export const TitleContainerStyled = styled(Grid2)({
  margin: '25px 0',
});

export const DataContainerStyled = styled(Grid2)({
  backgroundColor: '#F2F2F2',
  padding: 24,
  borderRadius: '4px',
});

export const ButtonGroupStyled = styled(ButtonGroup)(({ theme }) => ({
  borderRadius: '10px',
  border: `1px solid ${theme.palette.global.black}`,
}));

export const SelectedLengthBtnStyled = styled(Button)(() => ({
  borderRadius: '10px',
  backgroundColor: '#1471B3',
  color: '#FFFFFF',
  '&:hover': {
    backgroundColor: '#1471B3',
    color: '#FFFFFF',
  },
}));

export const MonthsBtnStyled = styled(Button)(({ theme }) => ({
  borderRadius: '10px',
  backgroundColor: theme.palette.global.white,
  color: theme.palette.global.black,
  '&:hover': {
    backgroundColor: '#1471B3',
    color: '#FFFFFF',
  },
}));

export const YearsSelectStyled = styled(Select)(({ theme }) => ({
  backgroundColor: theme.palette.global.white,
  border: `1px solid ${theme.palette.gray}`,
  borderRadius: '4px',
  fontSize: '16px',
  cursor: 'pointer',
  marginLeft: 4,
}));

export const YearOptionStyled = styled(MenuItem)(({ theme }) => ({
  backgroundColor: theme.palette.global.white,
  color: theme.palette.global.black,
  fontSize: '16px',
}));

export const BarChartStyled = styled(Box)({
  backgroundColor: '#FFFFFF',
  boxShadow: '0px 3px 6px #00000029',
  borderRadius: '4px',
  width: '100%',
  margin: '15px 0',
  padding: '12px',
});

export const PieChartStyled = styled(Box)({
  backgroundColor: '#FFFFFF',
  boxShadow: '0px 3px 6px #00000029',
  borderRadius: '4px',
  width: '100%',
  margin: '15px 0',
  padding: '12px',
  display: 'flex',
  justifyContent: 'center',
});

export const SchedulesChartStyled = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.global.white,
  boxShadow: '0px 3px 6px #00000029',
  borderRadius: '4px',
  width: '100%',
  margin: '15px 0',
  padding: '18px',
  height: '305px',
  overflowY: 'auto',
}));

export const SchedulesTitleStyled = styled(Typography)({
  fontWeight: 600,
});

export const SchedulesHeaderStyled = styled(Grid2)(({ theme }) => ({
  marginTop: '12px',
  borderBottom: `2px solid ${theme.palette.primary.main}`,
  padding: '8px',
}));

export const StatusSymbolStyled = styled(Box)({
  width: '0.8rem',
  height: '0.8rem',
  marginRight: '14px',
  borderRadius: '50%',
});
